import ApiService from "utils/services/ApiService";

interface EventLogVO {
	appName: string,
	appVersion: string,
	userId?: number,
	timestamp: number,
	eventType: string,
	eventCategory: string,
	initiator: string,
	initiatorCategory?: string,
	siteId?: number | null,
	orgId?: number,
	serviceURI: string,
	comments: string,
}

export async function addEventLog(eventType: string, eventCategory: string, siteId: number = 0, serviceURI: string = '', comments: string = '', attempts: number = 0) {

	if (!navigator.onLine) {
		return; //Don't bother if we're offline.
	}

	const loggedUser = JSON.parse(
		localStorage.getItem('user_information') ?? '{}'
	);
	function truncate(str: string, max = 250): string {
		if (!str) return '';
		if (str.length <= max) return str;
		return str.slice(0, max - 1) + '…';
	}
	let eventLog: EventLogVO = {
		appName: "Relay Web",
		appVersion: process.env.REACT_APP_ASSIGNED_VERSION ?? "1.0",
		userId: loggedUser?.id,
		timestamp: Date.now(),
		eventType: eventType,
		eventCategory: eventCategory,
		initiator: "User",
		initiatorCategory: (loggedUser?.userPermissionVOs ? loggedUser.userPermissionVOs[0]?.role : "USER") ?? "USER",
		siteId: (siteId !== 0 ? siteId : null),
		orgId: loggedUser?.organizationVO?.id,
		serviceURI: serviceURI,
		comments: truncate(comments),
	};

	try {
		await ApiService.addEventLog(eventLog);
	} catch (err) {
	if (attempts < 2 && eventType !== 'Event Log Failed') {

		await addEventLog(
			'Event Log Failed',
			eventCategory,
			siteId,
			serviceURI,
			`Failed to log: ${eventType} - ${err}`,
			attempts + 1
		);
	}
	console.warn('Event log failed:', err);
}

}